/*
Copyright 2019-present NAVER Corp.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
export const SELECTOR_NOT_SPECIFIED = "Element selector is not specified";
export const ORIENTATION_NOT_SPECIFIED = "Orientation is not correctly specified for Isometrizer";

export const MATRIX_VALUE_NOT_PROVIDED = "Values for matrix is not provided";
export const MATRIX_SHOULD_MUTIPLIED_WITH_OTHER_MATRIX = "Multiplyee for matrix should be another matrix";
export const VECTOR_OPERAND_NOT_VALIDATED = "Operand for vector is not in correct type";
export const VECTOR_PROPERTY_NOT_PROVIDED = "One of the Vector's 3 property(x, y, z) is not provided";
